import styled from 'styled-components';

import { designColor, floorGameDuration as duration, floorGameEasing as easing, styledReset } from '@pkg/primitives';

export const SearchWrapper = styled.div`
    display: grid;
    align-items: center;

    > input {
        grid-area: 1 / 1;
        padding: 4px 10px 10px 10px;
        width: 100%;
        height: 100%;
        font-size: 24px;
        font-weight: 700;
        border-radius: 10px;
        background-color: rgb(0, 0, 0, 0.06);
        outline: 2px solid transparent;
        outline-offset: 2px;
        transition-property: opacity, background-color, outline-color;
        transition-duration: ${duration.normal}ms;
        transition-timing-function: ${easing.cubic};

        &:disabled,
        &:read-only {
            opacity: 0.6;
        }

        &:focus-visible {
            outline-color: ${designColor.brandPurple};
        }

        &:focus,
        &:hover {
            background-color: rgb(0, 0, 0, 0.1);
        }

        &:active {
            background-color: rgb(0, 0, 0, 0.06);
        }

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            font-size: 36px;
        }
    }
`;

export const ClearActionWrapper = styled.div`
    // TODO: We have used this layout so that we can keep
    // the "Close" action real estate... but there are better solutions
    // to these layout shenanigans. To be resolved in the future.
    grid-area: 1 / 1;
    justify-self: end;
    transform: translateX(100%);
`;

export const ClearAction = styled.button.attrs({ type: 'button' })`
    && {
        ${styledReset.button}
        cursor: pointer;
        padding: 8px;
        text-decoration: underline;
        background-color: transparent;
        border-radius: 6px;
        outline: 2px solid transparent !important;
        outline-offset: 2px;
        transition-property: opacity, background-color, outline-color;
        transition-duration: ${duration.normal}ms;
        transition-timing-function: ${easing.cubic};
        // TODO: More position styles that should be revisited.
        margin-top: -4px;
        margin-left: 10px;

        &:disabled {
            opacity: 0.3;
        }

        &:focus-visible {
            outline-color: ${designColor.brandPurple} !important;
        }

        &:hover {
            background-color: ${({ theme }) => theme.shades.white['7']};
        }

        &:active {
            background-color: ${({ theme }) => theme.shades.white['4']};
        }
    }
`;
